import { redirect } from 'next/navigation';

export default function MeetingAttendanceRoot() {
  redirect('/meetingattendance/dashboard');
}
